import { httpManager } from './manager'

const apiHotmartAi = httpManager.create({ baseURL: process.env.API_HOTMART_AI })

export default apiHotmartAi
